import Vue from 'vue';
import Vuex from 'vuex';

import auth from './auth';
import checklists from './checklists';
import countries from './countries';
import regions from './regions';
import infopages from './infopages';
import logs from './logs';
import pppelements from './pppelements';
import statistics from './statistics';
import usermanual from './usermanual';
import notifications from './notifications';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        checklists,
        countries,
        regions,
        infopages,
        logs,
        pppelements,
        statistics,
        usermanual,
        notifications,
    },
});
